import { render, staticRenderFns } from "./shareLink.vue?vue&type=template&id=8326b27a&scoped=true&"
import script from "./shareLink.vue?vue&type=script&lang=js&"
export * from "./shareLink.vue?vue&type=script&lang=js&"
import style0 from "./shareLink.vue?vue&type=style&index=0&id=8326b27a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8326b27a",
  null
  
)

export default component.exports